"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Input = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _composeReactRefs = _interopRequireDefault(require("@seznam/compose-react-refs"));
var _Button = require("./Button");
var _icons = _interopRequireDefault(require("./constants/icons"));
var _ClearableInput = _interopRequireDefault(require("./styles/ClearableInput"));
var _shared = _interopRequireDefault(require("./styles/shared"));
var _excluded = ["className"],
  _excluded2 = ["containerClassName", "className", "label", "maxNumberText", "clearButtonProps"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Input = exports.Input = /*#__PURE__*/_react["default"].forwardRef(function Input(_ref, ref) {
  var className = _ref.className,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({
    ref: ref,
    type: "text",
    placeholder: " ",
    autoComplete: "off",
    className: (0, _classnames["default"])('input', className)
  }, props));
});
var fakeEvent = function fakeEvent(_ref2) {
  var type = _ref2.type,
    name = _ref2.name;
  return {
    target: {
      type: type || 'text',
      name: name,
      value: ''
    }
  };
};
var ClearableInput = /*#__PURE__*/_react["default"].forwardRef(function ClearableInput(_ref3, extRef) {
  var containerClassName = _ref3.containerClassName,
    className = _ref3.className,
    label = _ref3.label,
    maxNumberText = _ref3.maxNumberText,
    clearButtonProps = _ref3.clearButtonProps,
    props = (0, _objectWithoutProperties2["default"])(_ref3, _excluded2);
  var ref = (0, _react.useRef)();
  var isTextInput = props.type === 'text' || !props.type;
  var isNumberInput = props.type === 'number';
  var isClearable = isTextInput;
  var hasMaxLength = !!props.maxLength;
  var hasMaxOrMinNumber = !isNaN(props.max) || !isNaN(props.min);
  var hasUnderContent = hasMaxLength || hasMaxOrMinNumber;
  function clearAndFocusInput() {
    props.onChange(fakeEvent(props));
    ref.current.focus();
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('clearable-input has-float-label', containerClassName, _ClearableInput["default"].clearableInput, _shared["default"].controlContainer, hasUnderContent && _ClearableInput["default"].bumpBottomPadding)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('clearable-input__inner', _ClearableInput["default"].clearableInput__inner)
  }, /*#__PURE__*/_react["default"].createElement(Input, (0, _extends2["default"])({}, props, {
    ref: (0, _composeReactRefs["default"])(ref, extRef),
    className: (0, _classnames["default"])('clearable-input__input', _ClearableInput["default"].clearableInput__input, isClearable && _ClearableInput["default"].clearableInput__input_clearable, className)
  })), /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: props.id
  }, label), !!props.value && isTextInput && /*#__PURE__*/_react["default"].createElement(_Button.Button, (0, _extends2["default"])({
    type: "button",
    btnSize: "small",
    "aria-label": "Clear input",
    icon: _icons["default"].cross
  }, clearButtonProps, {
    className: (0, _classnames["default"])('clearable-input__clear', _ClearableInput["default"].clearableInput__clear, clearButtonProps.className),
    onClick: clearAndFocusInput
  }))), (hasMaxLength || hasMaxOrMinNumber) && /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('clearable-input__count', _ClearableInput["default"].clearableInput__count)
  }, hasMaxLength && isTextInput && "".concat(props.value.length, "/").concat(props.maxLength), hasMaxOrMinNumber && isNumberInput && maxNumberText(props)));
});
ClearableInput.displayName = 'ClearableInput';
ClearableInput.defaultProps = {
  maxNumberText: function maxNumberText(props) {
    return props.max ? "out of ".concat(props.max || '?') : "more than ".concat(props.min);
  },
  clearButtonProps: {}
};
var _default = exports["default"] = ClearableInput;